import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Menu } from '../types';

interface StandaloneItemsTabProps {
  menu: Menu;
}

/** Items sold directly on the menu without being built from a recipe (drinks, crisps, sides
 * bought straight off the shelf) - each row links through to its real Range Planning Items
 * detail page, same pattern as MenuStructureTab linking dishes through to RecipeV2. */
const StandaloneItemsTab = ({ menu }: StandaloneItemsTabProps) => {
  const { t } = useTranslation('menus');
  const navigate = useNavigate();
  const items = menu.standaloneItems ?? [];

  if (items.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noStandaloneItems', 'This menu has no standalone items added.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('itemNumber', 'Item Number')}</TableCell>
            <TableCell>{t('item', 'Item')}</TableCell>
            <TableCell>{t('category', 'Category')}</TableCell>
            <TableCell align="right">{t('price', 'Price')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow
              key={item.itemNumber}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(`/range-planning/items/${item.itemNumber}`)}
            >
              <TableCell>
                <Typography variant="textSM"
                  fontFamily="monospace">{item.itemNumber}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="textSM"
                  fontWeight={600}
                  color="primary.main">{item.description}</Typography>
              </TableCell>
              <TableCell>{item.category}</TableCell>
              <TableCell align="right">£{item.price.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StandaloneItemsTab;
